import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { STORE_PATH } from '@/shared/config';
import { Button, buttonVariants, PageHeading } from '@/shared/ui';

interface CustomizeUnavailableProps {
  readonly kind: 'not-found' | 'design-not-found' | 'error';
  readonly onRetry?: () => void;
}

const COPY = {
  'not-found': {
    title: '아직 커스터마이징을 준비 중인 상품입니다.',
    description: '편집영역이 공개되면 이 화면에서 디자인할 수 있습니다.',
  },
  'design-not-found': {
    title: '디자인을 찾을 수 없습니다.',
    description: '삭제됐거나 접근할 수 없는 디자인입니다.',
  },
  error: { title: '정보를 불러오지 못했습니다.', description: '잠시 뒤 다시 시도해 주세요.' },
} as const;

/** 커스터마이징 진입 불가 안내 — 편집영역 없음(not-found)·저장 디자인 없음(design-not-found)·조회 실패(error, 다시 시도). */
export const CustomizeUnavailable = ({
  kind,
  onRetry,
}: CustomizeUnavailableProps): ReactElement => (
  <section
    className="flex flex-col items-center gap-4 py-24 text-center"
    role={kind === 'error' ? 'alert' : undefined}
  >
    <PageHeading
      className="items-center text-center"
      title={COPY[kind].title}
      description={COPY[kind].description}
    />
    {kind === 'error' && onRetry !== undefined && (
      <Button variant="outline" size="sm" onClick={onRetry}>
        다시 시도
      </Button>
    )}
    <Link to={STORE_PATH} className={buttonVariants({ variant: 'outline', size: 'lg' })}>
      상품 목록으로
    </Link>
  </section>
);
